import { createContext } from 'react';
import { IServiceAchRelationshipsDto } from '@shared/api';
import { emptyFunc } from '@shared/react';
import { PaginationOptions } from '@features/Pagination';
import { IAchRelationshipsDesc } from './AchRelationshipsTableProvider';

export interface IAchRelationshipsTableContext {
    achRelationships: IServiceAchRelationshipsDto[];
    achRelationshipsLoading: boolean;
    paginationOptions: PaginationOptions | null;
    sortFieldName: string;
    desc: IAchRelationshipsDesc | null;
    handleSecuritiesSort: (fieldName: string) => void;
    setAlias: (cusip: string) => void;
}

export const AchRelationshipsTableContext = createContext<IAchRelationshipsTableContext>({
    achRelationships: [],
    achRelationshipsLoading: false,
    paginationOptions: null,
    sortFieldName: '',
    desc: null,
    handleSecuritiesSort: emptyFunc,
    setAlias: emptyFunc,
});
